import { Box, Center, Heading, Text, VStack, Button } from "@chakra-ui/react"
import { Home, AlertCircle } from "lucide-react"
import { useNavigate } from "react-router-dom"
import { AppCard } from "@/components/ui/AppCard"
import { Logo } from "@/components/Logo"

export const NotFound = () => {
  const navigate = useNavigate()

  return (
    <Box minH="100vh" bg="bg.muted">
      <Center p="4" minH="100vh">
        <VStack gap="8" width="full" maxW="400px">
          <Logo showText={true} />

          <AppCard p="10" textAlign="center">
            <VStack gap="6">
              <Box p="4" bg="red.500/10" borderRadius="full">
                <AlertCircle size={40} color="var(--chakra-colors-red-500)" />
              </Box>

              <VStack gap="2">
                <Heading size="xl" fontWeight="800" color="fg.default">
                  404
                </Heading>
                <Text color="fg.muted" fontWeight="medium">
                  Lo sentimos, la página que buscas no existe o ha sido movida.
                </Text>
              </VStack>

              <Button
                colorPalette="palomma"
                variant="solid"
                bg="brand.solid"
                width="full"
                size="lg"
                onClick={() => navigate("/")}
                gap="2"
              >
                <Home size={18} />
                Ir al inicio
              </Button>
            </VStack>
          </AppCard>

          <Text fontSize="xs" color="fg.subtle" fontWeight="medium">
            &copy; {new Date().getFullYear()} Palomma. Todos los derechos
            reservados.
          </Text>
        </VStack>
      </Center>
    </Box>
  )
}
